import React, { useState, useMemo, useEffect } from 'react';
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router';

import Config from '@app/dev/config/main';
import Loader from '@common/components/loader';

import CMSApi from '../../../services/cmsApi';
import CasinoAndLiveCasinoViewer from '../casinoAndLiveCasinoViewer';

import './style.scss';

export const CustomCasinoCategory = () => {
  const [data, setData] = useState({});
  const { categoryId, gameId } = useParams();
  const [providers, setProviders] = useState([]);
  const [selectedProviders, setSelectedProviders] = useState([]);
  const routePath = `/casino-category/${categoryId}`;
  const navigate = useNavigate();

  const loadGames = async (newSelectedProviders = []) => {
    const filter = { category: +categoryId };

    if (newSelectedProviders.length) filter.provider = newSelectedProviders.join(',');

    const { games } = await CMSApi.getCasinoGames(filter);
    return setData({ games });
  };

  const gameList = useMemo(() => data?.games, [data]);

  const loadProviders = async () => {
    const { providers: providersList } = await CMSApi.getCasinoProviders({
      only_providers: 1,
      categories: [+categoryId],
    });
    const { enabledProvidersList } = Config.casino;

    setProviders(
      enabledProvidersList?.length
        ? providersList.filter((provider) => enabledProvidersList.includes(provider.name))
        : providersList,
    );

    return providersList;
  };

  const toggleProvider = (provider) => {
    let newProviders = selectedProviders;

    if (selectedProviders.find((item) => item === provider)) {
      newProviders = selectedProviders.filter((item) => item !== provider);
    } else {
      newProviders = selectedProviders.concat(provider);
    }

    setSelectedProviders(newProviders);

    if (gameId) navigate(routePath);

    loadGames(newProviders);
  };

  useEffect(() => {
    loadGames();
    loadProviders();
  }, []);

  if (!data.games?.length) return <div className="loading"><Loader /></div>;

  return (
    <CasinoAndLiveCasinoViewer
      removeCategories
      removeSearch
      categoryId={categoryId}
      providers={providers}
      gameId={gameId}
      gamesData={{ list: gameList, total: gameList?.length }}
      routePath={routePath}
      toggleProvider={toggleProvider}
      selectedProviders={selectedProviders}
    />
  );
};
